import { render, staticRenderFns } from "./SeguimentoUpdate.vue?vue&type=template&id=395e7afe&"
import script from "./SeguimentoUpdate.vue?vue&type=script&lang=js&"
export * from "./SeguimentoUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports